//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum DynamoAxisType {
	Sql = 0,
	Months = 1,
	Years = 2
}
